import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import Form from '../../components/forms/ForwardInitiativeForm';
import { sendInitiative, withRedirect } from '../../CroActions';
import { breadcrumbs } from '../../../../actions/appActions';

const mapStateToProps = (state, { params }) => ({
  breadcrumbsItems: [{ label: 'Podněty k prošetření' }, { label: 'Postoupit podnět' }],
  initialValues: { id: params.id },
});
const onSubmit = withRedirect(sendInitiative, '/spravce/podnety');
export default connect(mapStateToProps, { onSubmit, breadcrumbs, goBack })(Form);